var map = {
	"./男-慢性肾病.png": "d8c1",
	"./男-慢性肾病0.png": "d8c18",
	"./男-慢性肾病1.png": "d8c18b",
	"./男-慢性肾病h.png": "d8c18b6",
	"./男-慢性阻塞性肺病.png": "4e03",
	"./男-慢性阻塞性肺病0.png": "4e030",
	"./男-慢性阻塞性肺病1.png": "4e030c",
	"./男-慢性阻塞性肺病h.png": "4e030c3",
	"./男-甲状腺癌.png": "4b49",
	"./男-甲状腺癌0.png": "4b49b",
	"./男-甲状腺癌1.png": "4b49be",
	"./男-甲状腺癌h.png": "4b49be9",
	"./男-糖尿病.png": "cd86",
	"./男-糖尿病0.png": "ab19",
	"./男-糖尿病1.png": "ab195",
	"./男-糖尿病h.png": "ab195a",
	"./男-结直肠癌.png": "6b3dd",
	"./男-结直肠癌0.png": "6b3d",
	"./男-结直肠癌1.png": "6b3ddf",
	"./男-结直肠癌h.png": "6b3ddfc",
	"./男-缺血性心血管病.png": "156ad",
	"./男-缺血性心血管病0.png": "156a",
	"./男-缺血性心血管病1.png": "156ada",
	"./男-缺血性心血管病h.png": "156ada7",
	"./男-肝癌.png": "987df",
	"./男-肝癌0.png": "987d",
	"./男-肝癌1.png": "987df7",
	"./男-肝癌h.png": "987df7c",
	"./男-肺癌.png": "15d29",
	"./男-肺癌0.png": "15d2",
	"./男-肺癌1.png": "15d290",
	"./男-肺癌h.png": "15d290a",
	"./男-胃癌.png": "10fac",
	"./男-胃癌0.png": "10fa",
	"./男-胃癌1.png": "10fac1",
	"./男-胃癌h.png": "10fac13",
	"./男-胰腺癌.png": "bc5a",
	"./男-胰腺癌0.png": "622f",
	"./男-胰腺癌1.png": "622f3",
	"./男-胰腺癌h.png": "622f3a",
	"./男-膀胱癌.png": "24be",
	"./男-膀胱癌0.png": "8496",
	"./男-膀胱癌1.png": "84960",
	"./男-膀胱癌h.png": "849601",
	"./男-食管癌.png": "ffb2",
	"./男-食管癌0.png": "f528",
	"./男-食管癌1.png": "f5280",
	"./男-食管癌h.png": "f52805",
	"./男-高血压.png": "4d0a",
	"./男-高血压0.png": "7c71",
	"./男-高血压1.png": "7c715",
	"./男-高血压h.png": "7c715a",
	"./男-鼻咽癌.png": "5f05",
	"./男-鼻咽癌0.png": "b670",
	"./男-鼻咽癌1.png": "b6700",
	"./男-鼻咽癌h.png": "b6700f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c393";